<template>
    <div class="list-logs" :class="[scrollbarClass, { 'no-scroll': !expandedSectionNav }]">
        <div class="item" v-for="log in logs">
            <details>
                <summary>
                    <div class="picture">
                        <img :src="log.user && log.user.avatar ? log.user.avatar : 'img/avatar.jpg'"/>
                    </div>
                    <div class="info-text">
                        <p class="text" v-html="log.title"></p>
                    </div>
                    <div class="date">
                        <p>{{ log.dateFormat }}</p>
                    </div>
                </summary>
                <div class="content" v-if="log.content" v-html="log.content"></div>
            </details>
        </div>
    </div>
</template>

<script>
import accessibilityMixin from '@/components/mixins/Accessibility.vue'

export default {
    mixins: [accessibilityMixin],
    props: {
        logs: { type: Array, default: () => [] },
        expandedSectionNav: { type: Boolean, default: false },
    },
}
</script>
